// src/globalState.js
import { reactive } from "vue";

export const globalState = reactive({
  tokenUpdated: false, // <- la bandera que vas a cambiar
  paymentCompleted: false, // <- nueva bandera para pago exitoso
  /** El interceptor de axios pide resetear flujo (JWT vencido / sin política Subscriber). */
  sessionInvalidated: false,
});
